import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { ImageCroppedEvent } from "ngx-image-cropper";

@Component({
	selector: "app-crop-image-modal",
	templateUrl: "./crop-image-modal.component.html",
	styleUrls: ["./crop-image-modal.component.scss"],
	standalone: false
})
export class CropImageModalComponent implements OnInit {
	file!: File;
	croppedImage = "";
	widthToResizeImage = 128;
	roundCropper = true;

	files!: FileList | null;

	constructor(private bsModalRef: BsModalRef) {}

	ngOnInit() {
		this.setImageToCrop(this.files);
	}

	closeModal(): void {
		this.croppedImage = "";
		this.bsModalRef.hide();
	}

	setImageToCrop(files: FileList | null): void {
		if (files) {
			this.file = files[0];
		}
	}

	imageCropped(event: ImageCroppedEvent) {
		if (event.base64) {
			this.croppedImage = event.base64;
		}
	}

	changeImage(): void {
		this.bsModalRef.hide();
	}
}
